import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { useRouter } from "next/router";
import { useEffect, useCallback, useState } from "react";
import { useIntersection } from "react-use";
import { onINP } from "web-vitals/attribution";
import { trackCriteo, trackPageView, trackWebVitalsMetric } from "./events";
import { getTrackingDataForPath } from "./utils";
import { useSiteInfo } from "../../SiteInfo/hooks/useSiteInfo";
var mapDataLayerSettings = function(siteSettings) {
    var ref, ref1;
    return {
        environment: siteSettings === null || siteSettings === void 0 ? void 0 : (ref = siteSettings.sessionData) === null || ref === void 0 ? void 0 : ref.gtmEnvironment,
        anonymizeIP: siteSettings === null || siteSettings === void 0 ? void 0 : (ref1 = siteSettings.sessionData) === null || ref1 === void 0 ? void 0 : ref1.anonymizeIP,
        locale: siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.language,
        language: siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.language,
        market: siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.market
    };
};
/**
 * React Hook to track custom pageView event on every route change
 */ var usePageView = function() {
    var siteInfo = useSiteInfo();
    var router = useRouter();
    var triggerEvent = useCallback(function() {
        var _ref = _async_to_generator(function(path) {
            var settings, data;
            return _ts_generator(this, function(_state) {
                if (siteInfo.settingsLoaded) {
                    settings = mapDataLayerSettings(siteInfo.settings);
                    data = getTrackingDataForPath(settings, path);
                    trackPageView(data);
                    if (!siteInfo.settings.isInternalCall) {
                        trackCriteo();
                    }
                }
                return [
                    2
                ];
            });
        });
        return function(path) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        siteInfo.settingsLoaded
    ]);
    // initial page view tracking
    useEffect(function() {
        if (router.isReady && siteInfo.settingsLoaded) {
            triggerEvent(router.asPath);
        }
    }, [
        router.isReady,
        router.asPath,
        triggerEvent,
        siteInfo.settingsLoaded
    ]);
    // route change page view tracking
    useEffect(function() {
        var handleRouteChange = function(path) {
            triggerEvent(path);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router.events,
        triggerEvent
    ]);
};
var useElementScrolledToView = function(ref, callback) {
    var _$ref = useState(false), seen = _$ref[0], setSeen = _$ref[1];
    var intersection = useIntersection(ref, {
        root: null,
        threshold: 1
    });
    useEffect(function() {
        if ((intersection === null || intersection === void 0 ? void 0 : intersection.isIntersecting) && !seen) {
            callback();
            setSeen(true);
        }
    }, [
        callback,
        intersection,
        seen
    ]);
};
/** @deprecated Use `next/web-vitals` when Next.js 13+ is available. */ var useReportWebVitals = function() {
    useEffect(function() {
        onINP(trackWebVitalsMetric, {
            reportAllChanges: true
        });
    // onLCP(trackWebVitalsMetric);
    // onCLS(trackWebVitalsMetric);
    // onFID(trackWebVitalsMetric);
    });
};
export { usePageView, useElementScrolledToView, useReportWebVitals };
